const Footer = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Latest Fix', id: 'latest-biscuit' },
    { label: 'The Shop', id: 'shop' },
    { label: 'Tool Bench', id: 'tool-bench' },
    { label: 'Beer Map', id: 'beer-map' },
    { label: 'Newsletter', id: 'newsletter' },
  ];

  const resourceLinks = [
    { label: 'Subscribe on YouTube', href: 'https://www.youtube.com/@beerafterwork' },
    { label: 'Latest Videos', href: 'https://www.youtube.com/@beerafterwork/videos' },
    { label: 'About the Channel', href: '#' },
    { label: 'Privacy Policy', href: '#' },
    { label: 'Contact', href: '#' },
  ];

  return (
    <footer className="w-full bg-[#0d0d0d]">
      {/* Top amber border */}
      <div className="w-full h-[2px] bg-gradient-to-r from-transparent via-[#f5a623] to-transparent" />

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Left: Brand */}
          <div className="flex flex-col gap-6">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#f5a623] rounded-md">
                <i className="ri-tools-fill text-black text-lg" />
              </div>
              <span className="font-['Bebas_Neue'] text-xl text-white tracking-widest">
                BEER AFTER WORK
              </span>
            </div>
            <p className="text-[#6a6a6a] text-sm font-['Merriweather'] italic leading-relaxed max-w-xs">
              Fix it for the biscuit. Every project earns a cold one.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-youtube-fill', href: 'https://www.youtube.com/@beerafterwork', label: 'YouTube' },
                { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/profile.php?id=100091842761853', label: 'Facebook' },
                { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
                { icon: 'ri-tiktok-fill', href: 'https://www.tiktok.com/@beerafterwork0', label: 'TikTok' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center border border-[#2a2a2a] rounded-full text-[#6a6a6a] hover:text-[#f5a623] hover:border-[#f5a623] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Center: Workshop Links */}
          <div className="flex flex-col gap-4">
            <h4 id="footer-workshop" className="font-['Roboto'] font-bold text-xs tracking-[3px] uppercase text-[#f5a623]">
              <a href="#workshop">THE WORKSHOP</a>
            </h4>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-left text-[#9a9a9a] text-sm font-['Roboto'] hover:text-[#f5a623] transition-colors duration-200 cursor-pointer w-fit whitespace-nowrap"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Right: Resources */}
          <div className="flex flex-col gap-4">
            <h4 id="footer-resources" className="font-['Roboto'] font-bold text-xs tracking-[3px] uppercase text-[#f5a623]">
              <a href="#resources">RESOURCES</a>
            </h4>
            <div className="flex flex-col gap-3">
              {resourceLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target={link.href.startsWith('http') ? '_blank' : undefined}
                  rel={link.href.startsWith('http') ? 'nofollow noopener noreferrer' : undefined}
                  className="text-[#9a9a9a] text-sm font-['Roboto'] hover:text-[#f5a623] transition-colors duration-200 w-fit whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1f1f1f] py-6 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center text-[#f5a623]">
              <i className="ri-tools-fill text-xs" />
            </div>
            <span className="text-[#444444] text-xs font-['Roboto']">
              © 2026 Beer After Work. Built in the garage.
            </span>
            <div className="w-4 h-4 flex items-center justify-center text-[#f5a623]">
              <i className="ri-goblet-fill text-xs" />
            </div>
          </div>
          <p className="text-[#333333] text-xs font-['Roboto']">
            Affiliate links on this site may earn a small commission.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
